export const CARD_PADDING = 15;
export const TOP_EDGE = 0;
export const ZOOM_RANGE = [0.2, 5];
export const MAX_CARDS = 1000;

const saveTheCatFormationSnapshot = {
  "2uVqD7": {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 0,
    },
    generated: false,
    height: 240,
    id: "2uVqD7",
    index: 1,
    placeholder: "This is a snapshot that instantly introduces us to the present world of the hero.",
    sourceCardIds: null,
    title: "Beat 1: Opening Image",
    type: "outline",
    width: 330,
    x: 0,
    y: 0,
  },
  "6LXWiL": {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 6,
    },
    generated: false,
    height: 240,
    id: "6LXWiL",
    index: 1,
    placeholder: "Introduce a secondary storyline or subplot. The B story usually involves a character (often a romantic interest) who’s integral to helping the hero undergo their transformation.",
    sourceCardIds: null,
    title: "Beat 7: B Story",
    type: "outline",
    width: 330,
    x: 1676.627999057785,
    y: 148.6101157464303,
  },
  AuFJTN: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 11,
    },
    generated: false,
    height: 240,
    id: "AuFJTN",
    index: 1,
    placeholder: "The hero experiences a moment of despair and introspection.",
    sourceCardIds: null,
    title: "Beat 12: Dark Night of the Soul",
    type: "outline",
    width: 330,
    x: 2690.3081162384938,
    y: -80.68770113239937,
  },
  Cxq8mB: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 9,
    },
    generated: false,
    height: 240,
    id: "Cxq8mB",
    index: 1,
    placeholder: "The stakes are raised and the villain begins to take a more active role in the story.",
    sourceCardIds: null,
    title: "Beat 10: Bad Guys Close In",
    type: "outline",
    width: 330,
    x: 2224.735754227948,
    y: -77.36251503640304,
  },
  Fpak6H: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 7,
    },
    generated: false,
    height: 240,
    id: "Fpak6H",
    index: 1,
    placeholder: "The protagonist experiences a series of challenges and obstacles on their journey.",
    sourceCardIds: null,
    title: "Beat 8: Fun and Games",
    type: "outline",
    width: 330,
    x: 1676.7298425825886,
    y: -272.52962972460216,
  },
  JD3J1v: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 4,
    },
    generated: false,
    height: 240,
    id: "JD3J1v",
    index: 1,
    placeholder: "The protagonist must decide whether to pursue their goal or return to their normal life.",
    sourceCardIds: null,
    title: "Beat 5: Debate",
    type: "outline",
    width: 330,
    x: 1146.929697494419,
    y: 24.499627517920057,
  },
  MW835P: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 13,
    },
    generated: false,
    height: 240,
    id: "MW835P",
    index: 1,
    placeholder: "The hero confronts the villain and saves the day, resolving the conflict.",
    sourceCardIds: null,
    title: "Beat 14: Finale",
    type: "outline",
    width: 330,
    x: 3307.781158390764,
    y: -83.61638917490137,
  },
  QdIXvu: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 14,
    },
    generated: false,
    height: 240,
    id: "QdIXvu",
    index: 1,
    placeholder: "A snapshot that mirrors or contrasts the opening image.",
    sourceCardIds: null,
    title: "Beat 15: Final Image",
    type: "outline",
    width: 330,
    x: 3365.6892346935624,
    y: 373.1697160604557,
  },
  SN2Bp1: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 1,
    },
    generated: false,
    height: 240,
    id: "SN2Bp1",
    index: 1,
    placeholder: "Introduces the central idea, or life lesson, that the hero will discover over the course of the story.",
    sourceCardIds: null,
    title: "Beat 2: Theme Stated",
    type: "outline",
    width: 330,
    x: 224.28156836356553,
    y: 542.1195697406054,
  },
  UrX49f: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 8,
    },
    generated: false,
    height: 240,
    id: "UrX49f",
    index: 3,
    placeholder: "A turning point in the story where the protagonist's journey takes a new direction. Stakes are raised by a plot twist that likely takes the form of a false victory.",
    sourceCardIds: null,
    title: "Beat 9: Midpoint",
    type: "outline",
    width: 330,
    x: 2086.8186744822137,
    y: -572.0295336875288,
  },
  c95Med: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 5,
    },
    generated: false,
    height: 240,
    id: "c95Med",
    index: 1,
    placeholder: "The protagonist decides to pursue their goal and sets out on their journey.",
    sourceCardIds: null,
    title: "Beat 6: Break into Two",
    type: "outline",
    width: 330,
    x: 1310.8892675714733,
    y: 486.5436585646594,
  },
  hQUWNe: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 10,
    },
    generated: false,
    height: 240,
    id: "hQUWNe",
    index: 1,
    placeholder: "The hero experiences a major loss, typically in the form of a defeat or setback.",
    sourceCardIds: null,
    title: "Beat 11: All is Lost",
    type: "outline",
    width: 330,
    x: 2377.428678621606,
    y: 375.88042333492564,
  },
  kHg86z: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 3,
    },
    generated: false,
    height: 240,
    id: "kHg86z",
    index: 4,
    placeholder: "An event or realization that sets the protagonist on their journey.",
    sourceCardIds: null,
    title: "Beat 4: Catalyst",
    type: "outline",
    width: 330,
    x: 834.1164181601393,
    y: -459.69001368983254,
  },
  lJgotO: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 12,
    },
    generated: false,
    height: 240,
    id: "lJgotO",
    index: 2,
    placeholder: "The hero makes a decision that sets them on the path towards a resolution.",
    sourceCardIds: null,
    title: "Beat 13: Break into Three",
    type: "outline",
    width: 330,
    x: 2917.6615549693356,
    y: -575.813230218562,
  },
  v4MlBu: {
    autoHeight: true,
    content: "",
    createdAt: 1675379912672,
    data: {
      beatId: 2,
    },
    generated: false,
    height: 240,
    id: "v4MlBu",
    index: 1,
    placeholder: "Introduce the protagonist and their normal world.",
    sourceCardIds: null,
    title: "Beat 3: Set-Up",
    type: "outline",
    width: 330,
    x: 589.8196469826049,
    y: -27.270075075602335,
  },
};

const romanceFormationSnapshot = {
  "6PWHcb": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 1
    },
    "generated": false,
    "height": 240,
    "id": "6PWHcb",
    "index": 15,
    "placeholder": "A unique meeting between two or more characters in the romance.",
    "sourceCardIds": null,
    "title": "Part 2: First Encounter",
    "type": "outline",
    "width": 330,
    "x": 3800.2569033442405,
    "y": 948.5577445053877
  },
  "8XFovZ": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 8
    },
    "generated": false,
    "height": 240,
    "id": "8XFovZ",
    "index": 35,
    "placeholder": "One or more characters in the romance believes the romance is over or impossible to repair.",
    "sourceCardIds": null,
    "title": "Part 9: Doubt and Despair",
    "type": "outline",
    "width": 330,
    "x": 6657.54512002027,
    "y": 1215.8276833106854
  },
  "8e2F84": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 0
    },
    "generated": false,
    "height": 240,
    "id": "8e2F84",
    "index": 14,
    "placeholder": "Establish at least one character in the romance in that character’s ordinary world",
    "sourceCardIds": null,
    "title": "Part 1: Ordinary World",
    "type": "outline",
    "width": 330,
    "x": 3301.8125,
    "y": 1043.5
  },
  "A2zZUC": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 6
    },
    "generated": false,
    "height": 240,
    "id": "A2zZUC",
    "index": 33,
    "placeholder": "A problem from the B plot creates an obstacle to further development of the romantic relationship.",
    "sourceCardIds": null,
    "title": "Part 7: Obstacle Arises",
    "type": "outline",
    "width": 330,
    "x": 5941.222818652717,
    "y": 1040.8001221427983
  },
  "EnWHci": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 7
    },
    "generated": false,
    "height": 240,
    "id": "EnWHci",
    "index": 34,
    "placeholder": "The Characters in the romance relationship struggle to find a solution to the problem from the B plot.",
    "sourceCardIds": null,
    "title": "Part 8: Problem-Solving Partnership",
    "type": "outline",
    "width": 330,
    "x": 6305.815936662881,
    "y": 455.2634212856764
  },
  "QC1wWN": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 3
    },
    "generated": false,
    "height": 240,
    "id": "QC1wWN",
    "index": 30,
    "placeholder": "Introduce a B plot story problem for one or more of the characters in the romance.",
    "sourceCardIds": null,
    "title": "Part 4: Secondary Plot Twist",
    "type": "outline",
    "width": 330,
    "x": 4606.611341976548,
    "y": 1261.4880663116041
  },
  "afq21M": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 11
    },
    "generated": false,
    "height": 240,
    "id": "afq21M",
    "index": 38,
    "placeholder": "The characters in the romance live happily ever after or happily for now.",
    "sourceCardIds": null,
    "title": "Part 12: Ever After",
    "type": "outline",
    "width": 330,
    "x": 7973.3312809104245,
    "y": 131.41987027030447
  },
  "gVqxzc": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 4
    },
    "generated": false,
    "height": 240,
    "id": "gVqxzc",
    "index": 31,
    "placeholder": "A compelling reason why the characters in the romance cannot simply never see each other again.",
    "sourceCardIds": null,
    "title": "Part 5: Unbreakable Ties",
    "type": "outline",
    "width": 330,
    "x": 5110.950597402249,
    "y": 881.445380045323
  },
  "iXIiar": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 9
    },
    "generated": false,
    "height": 240,
    "id": "iXIiar",
    "index": 36,
    "placeholder": "One or more characters is inspired to make a grand romantic gesture to overcome the problem from the B plot.",
    "sourceCardIds": null,
    "title": "Part 10: Grand Romantic Declaration",
    "type": "outline",
    "width": 330,
    "x": 7014.050564486936,
    "y": 381.7139859215791
  },
  "rhe3d6": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 2
    },
    "generated": false,
    "height": 240,
    "id": "rhe3d6",
    "index": 29,
    "placeholder": "A situation that results in a strong emotional reaction in one or more characters in the romance.",
    "sourceCardIds": null,
    "title": "Part 3: Emotional Stir",
    "type": "outline",
    "width": 330,
    "x": 4246.900987691208,
    "y": 773.6770474830505
  },
  "sMXLwl": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 10
    },
    "generated": false,
    "height": 240,
    "id": "sMXLwl",
    "index": 37,
    "placeholder": "The characters in the romance work together to solve any final obstacles that remain and enjoy a highly intimate romantic moment.",
    "sourceCardIds": null,
    "title": "Part 11: Happy Resolution",
    "type": "outline",
    "width": 330,
    "x": 7496.655529543421,
    "y": 287.7762829590093
  },
  "wOOgpQ": {
    "autoHeight": true,
    "content": "",
    "createdAt": 1675788219958,
    "data": {
      "beatId": 5
    },
    "generated": false,
    "height": 240,
    "id": "wOOgpQ",
    "index": 32,
    "placeholder": "A romantic act or gesture occurs between two or more characters in the romance.",
    "sourceCardIds": null,
    "title": "Part 6: Romantic Gesture",
    "type": "outline",
    "width": 330,
    "x": 5593.331459593127,
    "y": 565.6212965808663
  }
};


const getFormation = (formation, offset = [0, 0]) => {
  let sorted = Object.keys(formation)
    .sort((a, b) => {
      // sort by x
      if (formation[a].x < formation[b].x) {
        return -1;
      } else {
        return 1;
      }
    })
    .map((id) => {
      return { x: formation[id].x, y: formation[id].y };
    });

  const anchor = sorted[0];

  return sorted.map((point, i) => {
    if (i === 0) {
      return offset;
    } else {
      return [point.x - anchor.x + offset[0], point.y - anchor.y + offset[1]];
    }
  });
};

export const saveTheCatFormation = (offset) => {
  return getFormation(saveTheCatFormationSnapshot, offset);
};

export const romanceFormation = (offset) => {
  return getFormation(romanceFormationSnapshot, offset);
};


export const sampleCanvas = {
  cards: {
    "1CegiP": {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 5,
      },
      generated: false,
      height: 240,
      id: "1CegiP",
      index: 175,
      placeholder: "The Hero meets people who will help or harm them, and learns the rules of the Special World.",
      sourceCardIds: null,
      title: "Part 6: Tests, Allies, Enemies",
      type: "outline",
      width: 330,
      x: 3508.8242770666952,
      y: 1898.4404749487207,
    },
    "3Y0s8n": {
      autoHeight: true,
      content:
        "Detective LaBlanche, who is famous for her unique ability to see three minutes into the future, works with Chuck Gross to stop Auguste Azul, an international art thief, from stealing art and collapsing the French government.\n\nLabBlanche uses her skill to outsmart Auguste Azul.",
      createdAt: 1675750914251,
      data: {
        type: "heros",
      },
      generated: false,
      height: 370,
      id: "3Y0s8n",
      index: 232,
      placeholder: null,
      sourceCardIds: null,
      title: null,
      type: "outline_header",
      width: 600,
      x: 2915.9214227264342,
      y: 55.831413214729714,
    },
    "3nQd5s": {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 4,
      },
      generated: false,
      height: 240,
      id: "3nQd5s",
      index: 174,
      placeholder: "The hero takes the first step from the ordinary world into the special world.",
      sourceCardIds: null,
      title: "Part 5: Crossing the Threshold",
      type: "outline",
      width: 330,
      x: 3846.258999779201,
      y: 1628.492696778716,
    },
    "8OXtbP": {
      autoHeight: true,
      content: "✨Try this: select the above cards and click “Generate more like this”.",
      createdAt: 1671065296723,
      generated: false,
      height: 117,
      id: "8OXtbP",
      index: 127,
      sourceCardIds: null,
      type: "label",
      width: 621.2260009138803,
      x: 787.2554041763468,
      y: 773.9487365064845,
    },
    "8wct6s": {
      autoHeight: false,
      content: "Auguste Azul, our antagonist, is an international art thief. His goal is to steal enough art to fund the collapse of the French government, which he views as outdated and corrupt",
      createdAt: 1671062632668,
      generated: false,
      height: 230.71954228979334,
      id: "8wct6s",
      index: 276,
      sourceCardIds: null,
      type: "text",
      width: 282.18581435605597,
      x: 1443.8882221325605,
      y: 440.3555888454672,
    },
    AFxVDQ: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 8,
      },
      generated: false,
      height: 240,
      id: "AFxVDQ",
      index: 178,
      placeholder: "The Hero survives “death” at great cost, earning the reward they first sought.",
      sourceCardIds: null,
      title: "Part 9: The Reward",
      type: "outline",
      width: 330,
      x: 2249.500747665707,
      y: 1628.4926967787162,
    },
    Bc5Wmd: {
      createdAt: 1671062765924,
      generated: false,
      height: 765,
      id: "Bc5Wmd",
      index: 162,
      sourceCardIds: null,
      type: "instructions",
      width: 676,
      x: -43.17809344025731,
      y: 43.56564467326537,
    },
    DjwAFp: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 3,
      },
      generated: false,
      height: 240,
      id: "DjwAFp",
      index: 173,
      placeholder: "The hero meets a wise figure who teaches the hero something that makes them ready accept the call to action.",
      sourceCardIds: null,
      title: "Part 4: Meeting the Mentor",
      type: "outline",
      width: 330,
      x: 3969.768680410936,
      y: 1259.7371741033235,
    },
    I4BYcz: {
      autoHeight: false,
      content: "Chuck Gross, LaBlanche's closest confidante. He supplies her with information and has his own mission - to one day retire from the industry and run a small pottery studio",
      createdAt: 1671062533105,
      generated: false,
      height: 245.25,
      id: "I4BYcz",
      index: 251,
      sourceCardIds: null,
      type: "text",
      width: 273.72326738560355,
      x: 1100.4223761670403,
      y: 443.158577689537,
    },
    Lx85ky: {
      autoHeight: true,
      content: "✨Try this: select Auguste's card and click “Visualize” to generate a portrait.",
      createdAt: 1671065344318,
      generated: false,
      height: 159,
      id: "Lx85ky",
      index: 122,
      sourceCardIds: null,
      type: "label",
      width: 668.4781564488827,
      x: 1444.3597431729552,
      y: 772.7052071912337,
    },
    MIWhWm: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914251,
      data: {
        beatId: 0,
      },
      generated: false,
      height: 240,
      id: "MIWhWm",
      index: 298,
      placeholder: "Establish who the hero is and what their normal life is like.",
      sourceCardIds: null,
      title: "Part 1: The Ordinary World",
      type: "outline",
      width: 330,
      x: 3047.8798737224547,
      y: 522.2261287525387,
    },
    UAoFhO: {
      autoHeight: true,
      content: "👥 Characters",
      createdAt: 1671062269847,
      generated: false,
      height: 76,
      id: "UAoFhO",
      index: 137,
      sourceCardIds: null,
      type: "label",
      width: 400,
      x: 798.018854131695,
      y: 13.012568669414847,
    },
    dBPnGl: {
      autoHeight: false,
      content: {
        prompt: "A caseworker is sitting at a desk in an office, going through papers",
        url: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite-images/image-1.0-njYHrV1hr6n2fK6-0.png",
      },
      createdAt: 1671122607557,
      generated: true,
      height: 256,
      id: "dBPnGl",
      index: 156,
      sourceCardIds: ["I4BYcz"],
      type: "image",
      width: 256,
      x: 1098.8124681744603,
      y: 118.16754482736134,
    },
    eCXghC: {
      autoHeight: false,
      content: "Detective LaBlanche is a 30 year old French woman who is famous for her unique ability to see three minutes into the future",
      createdAt: 1671062341954,
      generated: false,
      height: 240,
      id: "eCXghC",
      index: 189,
      sourceCardIds: null,
      type: "text",
      width: 279.97679913124614,
      x: 797.7610983686695,
      y: 443.36454106855314,
    },
    exi7RG: {
      autoHeight: false,
      content: {
        prompt: "Detective LaBlanche is a 30 year old French woman who is famous for her unique ability to see three minutes into the future, digital art, film still, majestic HD",
        url: "https://sudoart.s3.us-east-2.amazonaws.com/sudowrite-images/image-1.0-fwOfcVnvXHW5Rt1-0.png",
      },
      createdAt: 1671122590815,
      generated: true,
      height: 256,
      id: "exi7RG",
      index: 98,
      sourceCardIds: ["eCXghC"],
      type: "image",
      width: 256,
      x: 795.7345541952643,
      y: 113.81609730016521,
    },
    fp9FZk: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 6,
      },
      generated: false,
      height: 240,
      id: "fp9FZk",
      index: 176,
      placeholder: "The Hero must prepare or evolve in order to tackle the Journey’s heart or central ordeal.",
      sourceCardIds: null,
      title: "Part 7: Approaching the Inner Cave",
      type: "outline",
      width: 330,
      x: 3047.8798737224547,
      y: 1997.2482194541085,
    },
    hT0RWH: {
      autoHeight: false,
      content: '✨Try this: click "Generate full outline"',
      createdAt: 1671065326068,
      generated: false,
      height: null,
      id: "hT0RWH",
      index: 295,
      sourceCardIds: null,
      type: "label",
      width: 695.3225185574125,
      x: 2081.3822516679356,
      y: 173.0602282782037,
    },
    iEjQjX: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 11,
      },
      generated: false,
      height: 240,
      id: "iEjQjX",
      index: 231,
      placeholder: "The hero returns with the love, wisdom, magic, etc. to heal a wounded land in the ordinary world.",
      sourceCardIds: null,
      title: "Part 12: Return with the Elixir",
      type: "outline",
      width: 330,
      x: 2586.9354703782137,
      y: 621.0338732579264,
    },
    irCjC7: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914251,
      data: {
        beatId: 1,
      },
      generated: false,
      height: 240,
      id: "irCjC7",
      index: 171,
      placeholder: "Something happens that forces the hero to step outside their comfort zone.",
      sourceCardIds: null,
      title: "Part 2: The Call to Adventure",
      type: "outline",
      width: 330,
      x: 3508.8242770666952,
      y: 621.0338732579263,
    },
    odOs3N: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 7,
      },
      generated: false,
      height: 240,
      id: "odOs3N",
      index: 177,
      placeholder: "The hero faces the central life-or-death challenge and experiencing “death”.",
      sourceCardIds: null,
      title: "Part 8: The Ordeal",
      type: "outline",
      width: 330,
      x: 2586.9354703782137,
      y: 1898.4404749487205,
    },
    p2TWqu: {
      autoHeight: true,
      content: "🗺️ Outline",
      createdAt: 1671062322883,
      generated: false,
      height: 76,
      id: "p2TWqu",
      index: 293,
      sourceCardIds: null,
      type: "label",
      width: 400,
      x: 2095.248159649203,
      y: 79.70484029838286,
    },
    qR6vC8: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 9,
      },
      generated: false,
      height: 240,
      id: "qR6vC8",
      index: 179,
      placeholder: "The hero is forced to return to the ordinary world.",
      sourceCardIds: null,
      title: "Part 10: The Road back Home",
      type: "outline",
      width: 330,
      x: 2125.9910670339714,
      y: 1259.7371741033235,
    },
    skt8PG: {
      autoHeight: false,
      content: '✨Next: click on Part 1 and click "Generate options for this card"',
      createdAt: 1675787759107,
      data: {},
      generated: false,
      height: null,
      id: "skt8PG",
      index: 300,
      placeholder: null,
      sourceCardIds: null,
      title: null,
      type: "label",
      width: 753.125,
      x: 2083.9375,
      y: 255.875,
    },
    uPqSpu: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914251,
      data: {
        beatId: 2,
      },
      generated: false,
      height: 240,
      id: "uPqSpu",
      index: 172,
      placeholder: "The hero initially refuses the call, because it is too far out of their confort zone.",
      sourceCardIds: null,
      title: "Part 3: Refusal of the Call",
      type: "outline",
      width: 330,
      x: 3846.258999779201,
      y: 890.981651427931,
    },
    yC3Arw: {
      autoHeight: true,
      content: "",
      createdAt: 1675750914252,
      data: {
        beatId: 10,
      },
      generated: false,
      height: 240,
      id: "yC3Arw",
      index: 230,
      placeholder: "The final test of the Hero’s transformation, they demonstrate mastery of their newfound abilities",
      sourceCardIds: null,
      title: "Part 11: Atonement",
      type: "outline",
      width: 330,
      x: 2249.500747665707,
      y: 890.9816514279308,
    },
  },
  groups: {
    GZcxw7: {
      cards: ["3Y0s8n", "MIWhWm", "irCjC7", "uPqSpu", "DjwAFp", "3nQd5s", "1CegiP", "fp9FZk", "odOs3N", "AFxVDQ", "qR6vC8", "yC3Arw", "iEjQjX"],
      id: "GZcxw7",
      title: "Outline",
      type: "outline",
    },
  },
  position: {
    x: -847,
    y: -151,
  },
  zoom: 0.64,
};
